import React, { useEffect, useState } from 'react'
import style from './Clock.module.css'
function Clock() {
    const [time,setTime]=useState(0);
    useEffect(()=>{
        setInterval(()=>{
            let mydate=new Date();
            setTime(mydate);
        },1000);
    },[time])
    const Months=["January","February","March","April","May","June","July","August","September","October","November","December"]
  return (
    <div className={style.clockWrapper}>
    <h2 className={style.timeblock}>
        {time && <span>{time.getHours()} : </span>}
        {time && <span>{("0"+time.getMinutes()).slice(-2)} : </span>}
        {time && <span>{("0"+time.getSeconds()).slice(-2)}</span>}
    </h2>
    <h3 className={style.date}>
    {time && <span>{time.getDate()} </span>}
    {time && <span>{Months[time.getMonth()]} </span>}
    {time && <span>{time.getFullYear()}</span>}
    </h3>
    </div>
  )
}

export default Clock